export default __webpack_public_path__ + "cb7aefc99e6363accc93ab6f0e2e06d6.png";